module.exports = __webpack_public_path__ + "static/media/img-emandamento-sansiro-04.72a68464.jpg";